function Loader({loading, content}) {

    function getLoaderIcon() {
        return (
            <div className="text-center">
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        loading === true ? getLoaderIcon() : content()
    );
}

export default Loader;
